// document.addEventListener('DOMContentLoaded', () => {
//   const header = document.querySelector('.section-header');
//   const nav = document.querySelector('#main-nav');
//   if (!header || !nav) return;

//   const CLOSE_DELAY = 0;
//   let closeTimer = null;

//   // IMPORTANT: adjust this selector to your mega dropdown container if needed
//   // Try one of these depending on theme:
//   const megaPanels = header.querySelectorAll('.mega-menu, .navigation__mega, .navigation__dropdown, .navigation__tier-2');
//   const getMegaPanelFrom = (el) => el?.closest?.('.mega-menu, .navigation__mega, .navigation__dropdown, .navigation__tier-2');

//   const setOpen = (on) => {
//     document.body.classList.toggle('mega-open', on);
//     header.classList.toggle('section-header--nav-hover', on);
//   };

//   const cancelClose = () => {
//     if (closeTimer) clearTimeout(closeTimer);
//     closeTimer = null;
//   };

//   const scheduleClose = () => {
//     cancelClose();
//     closeTimer = setTimeout(() => {
//       setOpen(false);
//     }, CLOSE_DELAY);
//   };

//   // Only top-level mega items should control opening
//   const topItems = nav.querySelectorAll('.navigation__tier-1 > .navigation__item--with-mega-menu');

//   topItems.forEach(li => {
//     li.addEventListener('mouseenter', () => {
//       cancelClose();
//       setOpen(true);
//     });

//     li.addEventListener('mouseleave', (e) => {
//       // If moving into the mega panel, don't close
//       const to = e.relatedTarget;
//       if (getMegaPanelFrom(to)) return;
//       scheduleClose();
//     });
//   });

//   // Keep open when hovering mega panel itself
//   megaPanels.forEach(panel => {
//     panel.addEventListener('mouseenter', () => {
//       cancelClose();
//       setOpen(true);
//     });

//     panel.addEventListener('mouseleave', (e) => {
//       // If moving back to a top item, don't close
//       const to = e.relatedTarget;
//       if (to && to.closest && to.closest('.navigation__tier-1 > .navigation__item--with-mega-menu')) return;
//       scheduleClose();
//     });
//   });

//   // If you move over logo/empty header area (like your point 3), close
//   // This fires when leaving nav+mega but still inside header.
//   header.addEventListener('mousemove', (e) => {
//     const inTopItem = e.target.closest?.('.navigation__tier-1 > .navigation__item--with-mega-menu');
//     const inMega = getMegaPanelFrom(e.target);
//     if (!inTopItem && !inMega) {
//       // you're in header but not in menu/mega area => close
//       scheduleClose();
//     }
//   }, { passive: true });
// });





document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const nav = document.querySelector('#main-nav, .navigation--left, #proxy-nav');
  if (!header || !nav) return;

  const BODY_CLASS = 'mega-open';
  const HEADER_CLASS = 'section-header--nav-hover';
  const CLOSE_DELAY = 250;
  let closeTimer = null;

  /* ------------------ helpers ------------------ */
  const cancelClose = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const openMega = () => {
    cancelClose();
    header.classList.add(HEADER_CLASS);
    document.body.classList.add(BODY_CLASS);
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer = setTimeout(() => {
      header.classList.remove(HEADER_CLASS);
      document.body.classList.remove(BODY_CLASS);
    }, CLOSE_DELAY);
  };

  const forceClose = () => {
    cancelClose();
    header.classList.remove(HEADER_CLASS);
    document.body.classList.remove(BODY_CLASS);
  };

  /* ---------------- Menu item hover ---------------- */
  nav.querySelectorAll('.navigation__item--with-mega-menu').forEach(item => {
    const link = item.querySelector('a');
    if (!link) return;

    link.addEventListener('mouseenter', openMega);
    link.addEventListener('mouseleave', scheduleClose);
  });

  /* ---------------- Mega panel hover ---------------- */
  // IMPORTANT: Add event listeners to ALL mega menu panels
  document.querySelectorAll('.navigation__tier-2-container').forEach(panel => {
    panel.addEventListener('mouseenter', openMega);
    panel.addEventListener('mouseleave', scheduleClose);
  });

  // Also add to any child elements that might be hovered
  document.querySelectorAll('.navigation__tier-2').forEach(tier2 => {
    tier2.addEventListener('mouseenter', openMega);
    tier2.addEventListener('mouseleave', scheduleClose);
  });

  // Add to promotion items if they exist
  document.querySelectorAll('.navigation__column--promotion').forEach(promo => {
    promo.addEventListener('mouseenter', openMega);
    promo.addEventListener('mouseleave', scheduleClose);
  });

  /* ---------------- Nav container hover ---------------- */
  nav.addEventListener('mouseenter', openMega);
  nav.addEventListener('mouseleave', scheduleClose);

  /* ---------------- Safety closes ---------------- */
  window.addEventListener('scroll', forceClose, { passive: true });
  
  document.addEventListener('pointerdown', e => {
    if (!header.contains(e.target)) forceClose();
  }, { passive: true });
  
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') forceClose();
  });

  // Debug helper
  console.log('Mega menu script loaded:', {
    header: header ? 'found' : 'not found',
    nav: nav ? 'found' : 'not found',
    megaPanels: document.querySelectorAll('.navigation__tier-2-container').length,
    megaItems: document.querySelectorAll('.navigation__item--with-mega-menu').length
  });
});